import cx from 'classnames';
import type { FC } from 'react';
import { Translation } from 'utils/translations';

import Link from 'components/Link';

import styles from './AccountPageNavigation.module.scss';

export type Page = {
  title: string;
  link: string;
};

type AccountPageNavigationProps = {
  pages: Page[];
  className?: string;
};

const AccountPageNavigation: FC<AccountPageNavigationProps> = ({
  pages,
  className,
}) => {
  if (!pages.length) {
    return null;
  }

  return (
    <div className={cx(styles['account-navigation'], className)}>
      {pages.map(({ title, link }) => (
        <Link
          key={link}
          activeStrategy="nested"
          className={(active) =>
            cx(styles['navigation-link'], {
              [styles.active]: active,
            })
          }
          to={link}
        >
          <Translation message={title} />
        </Link>
      ))}
    </div>
  );
};

export default AccountPageNavigation;
